import { render, staticRenderFns } from "./EdiInventory.vue?vue&type=template&id=d0ab20be&"
import script from "./EdiInventory.vue?vue&type=script&lang=js&"
export * from "./EdiInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports